<template>
    <AlertMessage
        type="warning"
        :show-icon="true"
        >{{ $tm('general.unsavedchanges') }}</AlertMessage
    >
</template>
<script lang="ts" setup>
import { AlertMessage } from '@/components';
import { $tm } from '@/locize';
</script>
